import './HexIcon.scss';

interface HexIconProps {
  icon:
    | 'icon icon-student'
    | 'icon icon-supervisor'
    | 'icon icon-subscriber'
    | 'icon icon-user'
    | 'icon icon-toga'
    | 'icon icon-home'
    | 'icon icon-tag'
    | 'icon icon-key-outline'
    | 'icon icon-key'
    | 'icon icon-bell'
    | 'icon icon-videolib'
    | 'icon icon-money'
    | 'icon icon-logout'
    | 'icon icon-print'
    | 'icon icon-email'
    | 'icon icon-more'
    | 'icon icon-calendar'
    | 'icon icon-receipt'
    | 'icon chevron-up'
    | 'icon key'
    | 'icon calendar'
    | 'icon print'
    | 'icon chevron-down'
    | 'fa-regular fa-book-open-cover'
    | string
  colorTheme: ColorTheme;
  size?: 'small' | 'medium' | 'regular';
  colorMode?: 'fill' | 'faded' | 'outlined';
  isTextIcon?: boolean; //this is true if inner icon is text
}

export type ColorTheme = 'dark' | 'green' | 'purple' | 'blue' | 'red' | 'yellow';

function HexIcon({ icon, colorTheme, isTextIcon = false, size = 'small', colorMode = 'faded' }: HexIconProps) {
  return (
    <div className={`hexagon-wrapper hex-icon-${colorTheme} hex-icon-${size} hex-${colorMode}`}>
      <i className="icon icon-hexagon hex-1" />
      {colorMode === 'outlined' && (
        <>
          <i className="icon icon-hexagon hex-2" />
          <i className="icon icon-hexagon hex-3" />
        </>
      )}
      {isTextIcon ? <div className="inner-icon">{icon}</div> : <i className={`${icon} inner-icon`} />}
    </div>
  );
}

export default HexIcon;
